import { render, staticRenderFns } from "./askariDetail.vue?vue&type=template&id=2e7983d0&scoped=true&"
import script from "./askariDetail.vue?vue&type=script&lang=js&"
export * from "./askariDetail.vue?vue&type=script&lang=js&"
import style0 from "./askariDetail.vue?vue&type=style&index=0&id=2e7983d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7983d0",
  null
  
)

export default component.exports